export const DRAWER_ACTIONS = {
  ADD_LESSON: 'ADD_LESSON',
  ADD_TRAILER: 'ADD_TRAILER',
  BATCH: 'BATCH',
  EDIT_LESSON: 'EDIT_LESSON',
  EDIT_TRAILER: 'EDIT_TRAILER',
};
